"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.arraySet = exports.objectSet = void 0;

var _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime/helpers/toConsumableArray"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _objectSpread3 = _interopRequireDefault(require("@babel/runtime/helpers/objectSpread"));

var _unmutable = _interopRequireDefault(require("./internal/unmutable"));

var objectSet = function objectSet(key, childValue) {
  return function (value) {
    return (0, _objectSpread3.default)({}, value, (0, _defineProperty2.default)({}, key, childValue));
  };
};

exports.objectSet = objectSet;

var arraySet = function arraySet(key, childValue) {
  return function (value) {
    key = key < 0 ? key + value.length : key;
    var clone = (0, _toConsumableArray2.default)(value);
    clone[key] = childValue;
    return clone;
  };
};

exports.arraySet = arraySet;

var _default = (0, _unmutable.default)({
  name: 'set',
  immutable: 'set',
  record: 'set',
  object: objectSet,
  array: arraySet
});

exports.default = _default;